<div *ngIf="user" class="assignee-icon {{size}}" [style.background-color]="user.color"
     [style.font-size.px]="user.initials.length > 2 ? 8 : 11">
  {{user.initials}}
</div>
